import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createBlock as _createBlock, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ai-tooltip__text"
}

import { computed } from 'vue';
import { Tippy } from 'vue-tippy';
import 'tippy.js/dist/tippy.css';


export default /*@__PURE__*/_defineComponent({
  __name: 'AiTooltip',
  props: {
    location: {},
    tooltipText: {},
    contentClass: {},
    top: { type: Boolean }
  },
  setup(__props: any) {



const documentBody = computed(() => document.body);

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock(_unref(Tippy), {
    "append-to": documentBody.value,
    "content-class": `ai-tooltip__info ${_ctx.contentClass}`,
    placement: _ctx.location,
    interactive: ""
  }, {
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, "content")
    ]),
    default: _withCtx(() => [
      (_ctx.tooltipText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.tooltipText), 1))
        : _createCommentVNode("", true),
      (_ctx.top)
        ? _renderSlot(_ctx.$slots, "top", { key: 1 })
        : _createCommentVNode("", true),
      (!_ctx.tooltipText && !_ctx.top)
        ? (_openBlock(), _createBlock(_component_inline_svg, {
            key: 2,
            src: require('@/assets/icons/IconQuestionMark.svg')
          }, null, 8, ["src"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["append-to", "content-class", "placement"]))
}
}

})